import { GetServerSideProps, GetStaticProps } from "next";
import { IHTMLSection } from "@/components/Content/interfaces";
import Section from "@/components/Content/Section";
import { getStaticPageData } from "@/helpers/api/service/Staticpage";
import { TypeSetInnerHTML } from "@/helpers/typeset";
import MetaSeo from "@/components/Head/Meta";
import SitelinkSearchBoxSEO from "@/components/Head/SitelinkSearchBox";
import { StaticPageProps } from "@/components/StaticPage/interface";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import {  updateOffCanvasView, updateOffCanvasViewPayload } from "@/store/slices/offCanvas";
import { useDispatch } from "react-redux";
import { getProfileData } from "@/helpers/api/service/profile";
import { useRouter } from "next/router";
import { getStudentIdLS } from "@/utils/auth";
import { appRedirectionInsight } from "@/helpers/api/service";
import { getMaskedMobile } from "@/utils/mobile";

const RedirectHome = dynamic(() => import("@/components/Content/RedirectHome"));

const HomePage = (props: StaticPageProps) => {
  const router = useRouter();
  const { login_source, student_id } = router?.query;
  const dispatch = useDispatch();
  const web_student_id = getStudentIdLS();
  const [webStudentId, setWebStudentId] = useState("");
  const { mobile } = props.redirectedOtpData || {};

  const appRedirection = async () => {
    const body = {
      student_id: Array.isArray(student_id) ? student_id[0] : student_id || "",
      login_source: Array.isArray(login_source) ? login_source[0] : login_source || "",
      web_student_id
    };

    const response = await appRedirectionInsight(body);
    if (response?.meta?.code == 200) {
      if (mobile) {
        dispatch(updateOffCanvasView({ name: "LOGIN" }));
        dispatch(updateOffCanvasViewPayload({
          LOGIN: {
            mobile,
            screen: "MOBILE",
            editable: true,
            method: "OTP",
            maskMobile: getMaskedMobile(mobile),
            web_student_id:webStudentId,
            student_id,
            login_source
          },
        }))
      }
    }
  }

  useEffect(() => {
    const checkWebStudentId = () => {
      const id = getStudentIdLS();
      if (id) {
        setWebStudentId(id);
      } else {
        setTimeout(checkWebStudentId, 200);
      }
    };
  
    checkWebStudentId();
  }, []);


  useEffect(() => {
    if (webStudentId && student_id) {
      appRedirection();
    }
  }, [webStudentId]);

  return (
    <RedirectHome>
      <div className={`static-content body-content ${props?.data.data.props?.className ?? ""}`}>
        <MetaSeo />
        <SitelinkSearchBoxSEO />
        <Section {...props.data.data} />
      </div>
    </RedirectHome>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { student_id } = ctx.query;

  const parsedStudentId: number | undefined = Array.isArray(student_id)
    ? parseInt(student_id[0])
    : student_id
      ? parseInt(student_id)
      : undefined;

  const filter = {
    title: "home",
    source: "category"
  };

  const { meta, data } = await getStaticPageData("en", filter);
  const profileData = await getProfileData(parsedStudentId, true);
  const mobile = profileData?.data?.mobile;

  if (!data || !(data as { data: IHTMLSection }).data || meta?.code !== 200) {
    if (meta?.code === 307 && data) {
      return {
        notFound: true,
      };
    }
    return {
      notFound: true,
    };
  }
  await TypeSetInnerHTML((data as { data: IHTMLSection }).data);

  return {
    props: {
      source: filter.source,
      data,
      redirectedOtpData: {
        mobile: mobile || null
      },
      breadcrumbs: {
        items: (data as { breadcrumbs: any }).breadcrumbs || null,
      },
      seo: (data as { seo: any }).seo || null,
      keywords: [],
    },
  };
};

export default HomePage;

